import { useTranslation } from 'react-i18next';
import List from '../../components/list/List';
import Map from '../../components/map/Map';
import Search from '../../components/search/Search';
import SupportTypeBar from '../../components/supportTypeBar/SupportTypeBar';
import './DesktopLayout.scss';
import { useShopsContext } from '../../contexts/ShopsContext';
import { SupportTypeEnum } from '../../../../utils/SupportTypeEnum';

const DesktopLayout = ({ types, fromPublic }) => {

  const { t } = useTranslation();
  const { fetchClusters, showSupportTypeFilters, selectedSupportType, setSelectedSupportType } = useShopsContext();

  const changeFilter = (selected) => {
    fetchClusters({
      wallet: selected
    })
  }

  return (
    <div className={`DesktopLayout ${fromPublic ? 'fromPublic' : ''}`}>
      {showSupportTypeFilters && !fromPublic && (
        <div className="DesktopLayout__header">
          <SupportTypeBar selectedSupportType={selectedSupportType} onChange={setSelectedSupportType} />
        </div>
      )}
      <div className="DesktopLayout__layout">
        <div className="DesktopLayout__layout__mapContainer">
          <Map />
        </div>
        <div className="DesktopLayout__layout__shopsListContainer">
          <Search />
          {selectedSupportType !== SupportTypeEnum.CREATOR && (
            <div className='DesktopLayout__layout__shopsListContainer__chips'>
              <button type="button" className={`DesktopLayout__layout__shopsListContainer__chips__item ${!types || types?.length < 1 ? 'selected' : ''}`} onClick={() => changeFilter(null)}>{t('Shops.filters.all')}</button>
              <button type="button" className={`DesktopLayout__layout__shopsListContainer__chips__item ${!types || types?.includes('LIVE_ARTS') ? 'selected' : ''}`} onClick={() => changeFilter('LIVE_ARTS')}>{t('Shops.filters.cultural')}</button>
              <button type="button" className={`DesktopLayout__layout__shopsListContainer__chips__item ${!types || types?.includes('DIGITAL_SUPPORT') ? 'selected' : ''}`} onClick={() => changeFilter('DIGITAL_SUPPORT')}>{t('Shops.filters.digital')}</button>
              <button type="button" className={`DesktopLayout__layout__shopsListContainer__chips__item ${!types || types?.includes('PHYSICAL_SUPPORT') ? 'selected' : ''}`} onClick={() => changeFilter('PHYSICAL_SUPPORT')}>{t('Shops.filters.physical')}</button>
            </div>
          )}
          <List isHorizontal={false} />
        </div>
      </div>
    </div>
  );
}

export default DesktopLayout;
